import type { SVGProps } from "react";

export default function ToolIcon(props: Readonly<SVGProps<SVGSVGElement>>) {
  return (
    <svg
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.4211 5.08758C10.1571 4.82356 10.0251 4.69156 9.9756 4.53934C9.93207 4.40544 9.93207 4.26122 9.9756 4.12732C10.0251 3.9751 10.1571 3.8431 10.4211 3.57908L12.3133 1.68684C11.8112 1.45974 11.2537 1.33333 10.6668 1.33333C8.45767 1.33333 6.6668 3.12419 6.6668 5.33333C6.6668 5.66069 6.70613 5.97886 6.78033 6.28339C6.85973 6.60949 6.89947 6.77253 6.89247 6.87553C6.88507 6.9834 6.869 7.0408 6.81927 7.13673C6.77173 7.2284 6.68073 7.3194 6.49869 7.50146L2.33349 11.6667C1.7812 12.2189 1.7812 13.1144 2.33349 13.6667C2.88577 14.2189 3.7812 14.2189 4.33349 13.6667L8.49867 9.50146C8.68073 9.3194 8.77173 9.2284 8.8634 9.18093C8.9594 9.1312 9.01673 9.11513 9.1246 9.10773C9.2276 9.10066 9.39067 9.1404 9.71673 9.2198C10.0213 9.294 10.3395 9.33333 10.6668 9.33333C12.8759 9.33333 14.6668 7.54246 14.6668 5.33333C14.6668 4.74639 14.5404 4.18898 14.3133 3.68684L12.4211 5.57908C12.1571 5.8431 12.0251 5.9751 11.8728 6.02456C11.7389 6.06806 11.5947 6.06806 11.4608 6.02456C11.3086 5.9751 11.1766 5.8431 10.9126 5.57908L10.4211 5.08758Z"
        stroke="#FF6653"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
